import { render, staticRenderFns } from "./trawl-divider.vue?vue&type=template&id=936a26b6"
import script from "./trawl-divider.vue?vue&type=script&lang=js"
export * from "./trawl-divider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports